export const FaqsList = [
  {
    sectionTitle: "General",
    items: [
      {
        question: "What is Bookkeeping and why do I need it?",
        answer: (
          <>
            Bookkeeping is the practice of recording and organizing daily financial transactions that occur within your company. It ensures
            that financial records are correct, up-to-date and complete.
            <br />
            <br />
            You need bookkeeping to lay the foundation for financial success. With properly managed books, you will always know your
            financial health and:
            <br />
            - Who owes you money
            <br />
            - Who you owe money to
            <br />
            - Cash flows
            <br />
            - Income and expense tracking
            <br />
            ...and so much more that will help you make informed decision on a daily basis.
          </>
        ),
      },
      {
        question: "What is the difference between Cash and Accrual Accounting?",
        answer: (
          <>
            Cash accounting records transactions when they happen. Simply put, when money is physically transferred in and out of your
            accounts, that income or expense is recorded.
            <br />
            <br />
            Accrual accounting records transactions when revenue is earned or an expense is billed. If you have 30 days to pay a bill, the
            expense is recorded when you are billed, not when you pay the bill.{" "}
          </>
        ),
      },
      {
        question: "How is Pinto different than other bookkeeping services?",
        answer: (
          <>
            Pinto is a modern day small business CFO. We work on the cloud and use proprietary software to help manage your books and
            finances to provide unmatched video based reports.
            <br />
            <br />
            Bookkeeping will always be a necessity in business but the antiquated methods will be soon left behind. We have rid of the
            hourly fee and aim to be your partner rather than &quot;the person you hate calling because of that hourly fee.&quot;
            <br />
            <br />
            We are constantly growing with technology and aim to be the best small business CFO service in today&apos;s world.
          </>
        ),
      },
    ],
  },
  {
    sectionTitle: "Pricing",
    items: [
      {
        question: "What if I do not know which plan I fit into?",
        answer:
          "Simply contact us and we will help figure out the right plan for you. We will also provide an explanation on why that is the correct plan for you.",
      },
      {
        question: "Does Pinto have any one-time fees",
        answer: (
          <>
            Yes, Pinto charges a one-time setup/onboarding fee equal to your first months fee.
            <br />
            <br />
            The setup/onboarding fee will be charged when you sign your agreement with Pinto.
            <br />
            <br />
            This fee allows us the necessary time to customize your account, better understand your business and meet with you during the
            first month of our partnership. We want this to be a smooth process and we will go above and beyond to make sure we are meeting
            your expectations.
          </>
        ),
      },
      {
        question: "Do you offer a Quarterly Plan?",
        answer: `No, We charge monthly or annually with a discount for paying annually.
          `,
      },
      {
        question: "Does the price change as my expense go up?",
        answer: (
          <>
            We guarantee your initial price for at least 1 year. If your business moves you into a different pricing tier, it is possible
            your pricing could change after the first year of service. That new rate would then be locked for another year.
            <br />
            <br />
            The only exception is if your business complexity significantly changes in the course of a year, which is a very rare
            circumstance. You will be notified before any changes occur.
          </>
        ),
      },
      {
        question: "Do you offer a Free Trial",
        answer: (
          <>
            We no longer offer a free trial.
            <br />
            <br />
            For Bookkeeping and Forecasting Monthly plans can be canceled at any time, prior to the next billing cycle. However, no refunds
            are given on monthly plans.
            <br />
            <br />
            Annual plans (paid up front), have a guarantee allowing you can cancel and receive a full refund, less the first month, within 7
            days of receiving your first monthly report.
            <br />
            <br />
            If you are renewing an annual contract or have received prior services, there is no refund period.
            <br />
            <br />
            All other fees are not refundable{" "}
          </>
        ),
      },
    ],
  },
  {
    sectionTitle: "Bookkeeping",
    items: [
      {
        question: "When can I expect my monthly report? What is included in the report?",
        answer: (
          <>
            Your monthly report will be sent to you within 10 business days of each month. Of course, our goal is to have your report to you
            much faster than 10 days.
            <br />
            <br />
            If any end of month items are required from you, the quicker those items are received the quicker we are able to get your report
            to you.
            <br />
            <br />
            You can see a Sample Report{" "}
            <a className="text-blue-600" href="https://usepinto.com/demo" target="_blank" rel="noreferrer">
              Here
            </a>
          </>
        ),
      },
      {
        question: "Do you really offer free and unlimited support?",
        answer: (
          <>
            Yes! However the type of support you receive is based off of your plan and the services you utilize.
            <br />
            <br />
            For example, our [Tier 1] [Core] plan only allows for email support whereas [Tier 2] [Select] allows for phone, text, zoom and
            slack support.
            <br />
            <br />
            Also, if you pay for bookkeeping only, we do not provide free support to discuss forecasting or analysis beyond what is provided
            in your report. We do have a retainer option if you’d like minimal support on topics outside of your current plan.
          </>
        ),
      },
      {
        question: "My books are not current? What if I've never kept clean financial records?",
        answer: (
          <>
            Don&apos;t Stress! You aren&apos;t alone and that is what we are here for.
            <br />
            <br />
            If your books are simply out of date, we will work with what you have and get you up to current.
            <br />
            <br />
            If you haven&apos;t kept financial records, we will start from ground zero and get you up to date as fast as we can.
          </>
        ),
      },
      {
        question: "What if my business and personal bank accounts are mixed?",
        answer: (
          <>
            Unfortunately, we do not work with co-mingled accounts.
            <br />
            <br />
            However, we would still like to meet you and offer help in getting your finances separated and in order. If we are able to work
            out a plan to separate business and personal accounts, we&apos;d be happy to manage your books for you.
          </>
        ),
      },
      {
        question: "I would like to close my account, how do I get my financial data?",
        answer: (
          <>
            First, we are sorry to see you go and we sincerely hope you were satisfied with our service.
            <br />
            <br />
            Since we use QuickBooks Online, an industry standard software, your data is downloadable and transferable to most any other
            software package. We will remove ourselves as the &quot;Master&quot; on your QuickBooks account and will no longer have access
            to any of your financial information. If we have access to any of your other 3rd party accounts or financial data, we will
            terminate our access to those as well.
            <br />
            <br />
            We are here to make sure you have what you need before our agreement terminates. Even though we are sad to see you go, we will
            not leave you stranded.
          </>
        ),
      },
      {
        question: "What accounting software do you work with?",
        answer: `We work solely with QuickBooks Online.

        We are able to convert from any platform to QuickBooks online if that is something you are considering. `,
      },
    ],
  },
  {
    sectionTitle: "Forecasting",
    items: [
      {
        question: "What can I expect with a budget or forecast from Pinto?",
        answer: (
          <>
            1.) We will email you a list of items to prepare for the initial meeting. The first meeting is the longest and most tedious, so
            being well prepared helps the initial forecast meeting move along efficiently.
            <br />
            <br />
            2.) Once the forecast is set, you will get a monthly, video based report.
            <br />
            <br />
            3.) We meet quarterly to review and make any adjustments going forward. We also add 3 months to your forecast so you are always
            planned a year into the future.
          </>
        ),
      },
      {
        question: "What if I want to meet more than once per quarter?",
        answer:
          "If you would like to meet more than once per quarter to review your forecast, you can select our retainer option to schedule more 1 on 1 time.",
      },
      {
        question: "How does a Forecast affect my monthly report?",
        answer: (
          <>
            Your monthly report will now include budget to actual and variance data. This provides significantly greater insights into your
            business and we are also able to accurately show expectations into the future, keeping you up to date on no only where you stand
            but where you are going.
            <br />
            <br />
            Having forecasted data on your report takes you from reactive to proactive in setting your business up for success.
          </>
        ),
      },
      {
        question: "What if I want to plan more than a year into the future?",
        answer: (
          <>
            Currently, we only plan for 1 year as we find we can make rather accurate educated decisions within a 12 month period. After
            that, it starts to become more of a guessing game and we don’t find that data as useful for driving business decisions.
            <br />
            <br />
            If you would like a forecast more than 1 year into the future for goal planning or investor/banking needs, reach out to us and
            we can work that out with you!
          </>
        ),
      },
      {
        question: "Does the forecast monitor my Cash Flow or just tell me if I’m profitable.",
        answer: `Cash is King, especially in small business. We absolutely tie cash flow into your forecast. You can be profitable and have cash related issues and our goal is to get in front of those cash issues as soon as we can.`,
      },
    ],
  },
  {
    sectionTitle: "Tax",
    items: [
      {
        question: "Does Pinto file my taxes for me?",
        answer: (
          <>
            Currently, we do not offer a tax service. However, we will provide you with an end of the year report that your tax accountant
            can use to file your taxes. This report includes your yearly financial statements as well as any adjustments, a tax map, and a
            1099 report to make your accounts job as easy as possible.
            <br />
            <br />
            This is a proven way to keep your tax season stress-free as well!
            <br />
            <br />
            We are currently working on adding a tax service to our business so we can be your full-service financial provider but in the
            meantime we do have referrals to trusted tax partners.
          </>
        ),
      },
      {
        question: " Does Pinto work with my tax partner?",
        answer: (
          <>
            After you submit the annual report (that we provide) to your tax accountant for tax filings, your accountant may run into
            questions or need clarification. We are here to work directly with your accountant if questions should arise.
            <br />
            <br />
            We have a great track record of providing support to 3rd party CPAs!
          </>
        ),
      },
    ],
  },
];
